export interface CompletedCyclesDataPoint {
	date: string;
	count: number;
}

export interface AllCyclesDataPoint {
	date: string;
	count: number;
}

export interface CompletedCyclesSeries {
	site?: {
		id: string;
		name: string;
	};
	points: CompletedCyclesDataPoint[];
}

export interface AllCyclesSeries {
	site?: {
		id: string;
		name: string;
	};
	points: AllCyclesDataPoint[];
}

export enum ChartViewType {
	Hours = 'hours',
	Days = 'days',
	Weeks = 'weeks',
	Months = 'months',
}

export enum CompletedCyclesTypeFilter {
	DEVICES = 'devices',
	LOCATIONS = 'locations',
	USERS = 'users',
}

export interface GetCompletedCyclesQueryParams {
	fromDate?: string;
	toDate?: string;
	customerId?: string;
	siteId?: string;
	locationId?: string;
}

export interface GetAllCyclesMultilineQueryParams {
	fromDate?: string;
	toDate?: string;
	completed?: boolean;
	locationId?: string;
}

export interface MostActiveUserResponse {
	user_id: string;
	user_firstName: string;
	user_lastName: string;
	count: number;
	complete_count: number;
	error_count: number;
	customer_name?: string;
	site_name?: string;
}

export interface MostActiveDeviceResponse {
	device_id: string;
	device_name: string;
	count: number;
	complete_count: number;
	error_count: number;
	customer_name?: string;
	site_name?: string;
}

export interface MostCleanedLocationResponse {
	id: string;
	names: string[];
	count: number;
	customer_name?: string;
	site_name?: string;
	complete_count: number;
}

export interface AllCyclesResponse {
	numberOfAllCycles: number;
	numberOfCompletedCycles?: number;
	numberOfCompletedCyclesPreviousPeriod?: number;
	percentDifference?: number;
	data: AllCyclesSeries[];
	view: ChartViewType;
}

export interface MostActiveUsersQueryParams {
	fromDate?: string;
	toDate?: string;
	customerId?: string;
	locationId?: string;
}

export interface MostActiveDevicesQueryParams {
	fromDate?: string;
	toDate?: string;
	customerId?: string;
	locationId?: string;
}

export interface GetAllCyclesQueryParams {
	fromDate?: string;
	toDate?: string;
	customerId?: string;
	siteId?: string;
	locationId?: string;
}

export type MostCleanedLocationsQueryParams = MostActiveUsersQueryParams;

export type ExportMostActiveUsersQueryParams = MostActiveUsersQueryParams;
export type ExportMostCleanedLocationsQueryParams = MostActiveUsersQueryParams;
